import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import ResponsiveExpander from '../shared/ResponsiveExpander';
import CountryFlag from '../countryflag/countryFlag';
import LANGUAGES_CONTROLLER from '../../controllers/languages';

const OpenReturnsTableRow = props => {
  const {
    data,
    statuses,
    expanded,
    handleRowClick,
    getAdjustedStartDate,
    today
  } = props;

  const {
    companyName,
    countryCode,
    countryCodeLong,
    dueDate,
    endDate,
    filingName,
    reportingStatus,
    vatNumber,
  } = data;

    // Note: filingName used rather than filingTypeId because some IDs are the same (i.e. Intrastat) for different filing names
  const rowIdentifier = `${countryCode}-${filingName}-${endDate}`;

  let statusList = statuses || [];

  return (
    <>
      <tr>
        <td>
          <span>
            {countryCodeLong &&
              <CountryFlag
                countryCode={countryCodeLong}
                showCode={true}
              />
            }
          </span>
        </td>
        <td>
          <span>
            {companyName} ({vatNumber})
          </span>
        </td>
        <td>
          <span>{filingName}</span>
        </td>
        <td>
          {!(_.isEmpty(data) || _.isEmpty(statusList)) &&
            <span>
              <span className={"openReturn-" + statusList[reportingStatus] && statusList[reportingStatus].shortName + "-icon"}/>
              <span>
                {LANGUAGES_CONTROLLER.format(props.languages, statusList[reportingStatus] && statusList[reportingStatus].languageString)}
              </span>
            </span>
          }
        </td>
        <td>
          <span>{getAdjustedStartDate(data)}</span>
        </td>
        <td>
          {data.endDate &&
            <span>
              {`${moment.utc(endDate).format('YYYY-MM-DD')}`}
            </span>
          }
        </td>
        <td>
          <span>{dueDate}</span>
        </td>
        <td>
          {dueDate &&
            <span>{`${moment.utc(dueDate, 'YYYY-MM-DD').diff(props.today, 'days')} days`}</span>
          }
        </td>
        <td onClick={() => handleRowClick(rowIdentifier)}>
          <ResponsiveExpander active={expanded} />
        </td>
      </tr>

      {expanded &&
        <tr className='row-collapse'>
          <td colSpan='9'>
            {/* TODO: new content */}
          </td>
        </tr>
      }
    </>
  )
}

export default OpenReturnsTableRow;